module.exports = __webpack_public_path__ + "static/media/KMH_5291.fa747479.jpg";